import { CALIBRATION_PROFILES_FETCH_ENTITIES } from '../action-types/calibration-profiles-types';

const initialState = {
  entities: [],
  entity: {},
  entityLoaded: false,
  loading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CALIBRATION_PROFILES_FETCH_ENTITIES.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CALIBRATION_PROFILES_FETCH_ENTITIES.SUCCESS:
      return {
        ...state,
        entities: [...action.payload.data],
        loading: false,
      };
    case CALIBRATION_PROFILES_FETCH_ENTITIES.REJECTED:
      return {
        ...state,
        loading: false,
        entities: [],
      };
    default:
      return state;
  }
}
